import React from 'react';
import { FadeIn } from './FadeIn';
interface SalesLetterProps {
  lang?: 'en' | 'es';
}
const t = {
  en: {
    title: 'The Real Cost of a Bad Beauty Experience',
    subtitle: "Waterbury's Home for Women Who Deserve to Feel Extraordinary",
    p1: "Let's talk about what really happens when a salon lets you down.",
    p2: "It's not just about the hair.",
    p3: "It's not just about the nails.",
    p4: "It's the drive home where you don't turn on music — you just sit in silence.",
    p5: "It's pulling your hair up the moment you get home so nobody sees it.",
    p6: "It's canceling plans because you don't feel like yourself.",
    p7: "It's looking in the mirror and feeling less than — when you deserved to feel like everything.",
    quote: "A bad beauty experience doesn't just affect your look. It affects your week, your confidence, and the way you show up in the world.",
    p8: 'And the worst part?',
    p9: 'You paid for it.'
  },
  es: {
    title: 'El Verdadero Costo de una Mala Experiencia de Belleza',
    subtitle: 'El Hogar en Waterbury para Mujeres que Merecen Sentirse Extraordinarias',
    p1: 'Hablemos de lo que realmente pasa cuando un salón te decepciona.',
    p2: 'No se trata solo del cabello.',
    p3: 'No se trata solo de las uñas.',
    p4: 'Es el camino a casa donde no enciendes la música — solo te sientas en silencio.',
    p5: 'Es recogerte el cabello en cuanto llegas a casa para que nadie lo vea.',
    p6: 'Es cancelar planes porque no te sientes tú misma.',
    p7: 'Es mirarte al espejo y sentirte menos — cuando merecías sentirte como todo.',
    quote: 'Una mala experiencia de belleza no solo afecta tu look. Afecta tu semana, tu confianza y la forma en que te presentas al mundo.',
    p8: '¿Y lo peor?',
    p9: 'Pagaste por ello.'
  }
};
export function SalesLetter({
  lang = 'en'
}: SalesLetterProps) {
  const text = t[lang];
  return <section className="py-24 md:py-32 bg-brand-dark text-brand-cream" data-id="element-306">
      <div className="max-w-[720px] mx-auto px-6" data-id="element-307">
        <FadeIn data-id="element-308">
          <div className="text-center mb-16" data-id="element-309">
            <h2 className="font-serif text-3xl md:text-5xl text-brand-gold mb-6" data-id="element-310">
              {text.title}
            </h2>
            <p className="font-sans text-[#C0C0C0] tracking-widest uppercase text-sm font-medium" data-id="element-311">
              {text.subtitle}
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-312">
          <div className="space-y-8 font-sans text-lg md:text-xl leading-relaxed text-brand-cream/80" data-id="element-313">
            <p data-id="element-314">{text.p1}</p>
            <p data-id="element-315">{text.p2}</p>
            <p data-id="element-316">{text.p3}</p>
            <p data-id="element-317">{text.p4}</p>
            <p data-id="element-318">{text.p5}</p>
            <p data-id="element-319">{text.p6}</p>
            <p data-id="element-320">{text.p7}</p>

            <div className="py-8" data-id="element-321">
              <div className="p-8 bg-brand-cream/5 border border-brand-gold/20 shadow-sm relative" data-id="element-322">
                <div className="absolute top-0 left-0 w-1 h-full bg-brand-gold" data-id="element-323"></div>
                <p className="font-serif text-2xl md:text-3xl text-brand-gold italic leading-snug" data-id="element-324">
                  {text.quote}
                </p>
              </div>
            </div>

            <p data-id="element-325">{text.p8}</p>
            <p className="font-medium text-brand-cream text-2xl" data-id="element-326">{text.p9}</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}